(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["before-after-results"] && !Shopify.designMode) return;
  try {
    (function(){
  if (customElements.get('crack-before-after')) return;
  var clamp = function(v, a, b){ return Math.max(a, Math.min(b, v)); };
  class CrackBeforeAfter extends HTMLElement {
    connectedCallback() {
      if (this._ready) return; this._ready = true;
      this.mode = this.dataset.mode || 'slider';
      this.n = parseInt(this.dataset.count, 10) || 1;
      this.speed = parseFloat(this.dataset.speed) || 2.5;
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.auto = this.dataset.auto === 'true' && !reduced;
      this.visible = false;
      if (this.mode === 'wall') this.initWall();
      else if (this.mode === 'strip') this.initStrip();
      else this.initSlider();
      var self = this;
      this.ioFired = false;
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function(es){ self.ioFired = true; self.visible = es[0].isIntersecting; if (self.visible) self.kick(); }, { threshold: 0.1 });
        this.io.observe(this);
      }
      setTimeout(function(){ if (!self.ioFired) { self.visible = true; self.kick(); } }, 300);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = null; this._ready = false;
      if (this._rs) window.removeEventListener('resize', this._rs);
    }
    kick() {
      if (this.raf) return;
      var self = this; this.last = performance.now();
      var loop = function(t){
        if (!self.visible) { self.raf = null; return; }
        if (!self.ioFired) { var r = self.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) { self.raf = requestAnimationFrame(loop); self.last = t; return; } }
        var dt = Math.min(0.05, (t - self.last) / 1000); self.last = t;
        if (self.mode === 'wall') self.tickWall(dt);
        else if (self.mode === 'strip') self.tickStrip(dt, t);
        else self.tickSlider(dt, t);
        self.raf = requestAnimationFrame(loop);
      };
      this.raf = requestAnimationFrame(loop);
    }

    /* ---------- Results wall ---------- */
    initWall() {
      var self = this;
      this.tiles = Array.prototype.slice.call(this.querySelectorAll('.cba-tile'));
      this.segs = Array.prototype.slice.call(this.querySelectorAll('.cba-segs span'));
      this.countEl = this.querySelector('.cba-count');
      this.allBtn = this.querySelector('[data-reveal-all]');
      this.manual = !this.auto; this.wT = 0;
      this.tiles.forEach(function(t){
        t.addEventListener('click', function(){ self.manual = true; self.setFlip(t, !t.classList.contains('is-flipped')); self.updWall(); });
      });
      if (this.allBtn) this.allBtn.addEventListener('click', function(){
        self.manual = true;
        var all = self.tiles.every(function(t){ return t.classList.contains('is-flipped'); });
        self.tiles.forEach(function(t){ self.setFlip(t, !all); });
        self.updWall();
      });
      this.updWall();
    }
    setFlip(t, v) { t.classList.toggle('is-flipped', v); t.setAttribute('aria-pressed', v ? 'true' : 'false'); }
    updWall() {
      var c = this.tiles.filter(function(t){ return t.classList.contains('is-flipped'); }).length;
      if (this.countEl) this.countEl.textContent = (this.countEl.dataset.template || '[count] of [total]').replace('[count]', c).replace('[total]', this.tiles.length);
      this.segs.forEach(function(s, i){ s.classList.toggle('is-on', i < c); });
      if (this.allBtn) this.allBtn.textContent = c === this.tiles.length ? this.allBtn.dataset.hide : this.allBtn.dataset.show;
    }
    tickWall(dt) {
      if (this.manual) return;
      this.wT += dt;
      var H = 1.2 + this.speed * 1.2, l = this.wT % (2 * H), self = this, changed = false;
      this.tiles.forEach(function(t, i){
        var f = l < H ? l > i * 0.15 + 0.4 : (l - H) < i * 0.15 + 0.4;
        if (f !== t.classList.contains('is-flipped')) { self.setFlip(t, f); changed = true; }
      });
      if (changed) this.updWall();
    }

    /* ---------- Drag slider ---------- */
    initSlider() {
      var self = this, f = this.frame = this.querySelector('.cba-frame');
      this.layers = Array.prototype.slice.call(this.querySelectorAll('.cba-layer'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('.cba-thumb'));
      this.pos = 50; this.grab = 0; this.idx = 0; this.sway = 0; this.sT = 0; this.idle = -1e9; this.drag = false;
      if (!f) return;
      var h = this.querySelector('.cba-handle');
      var set = function(e){ var r = f.getBoundingClientRect(); self.setPos((e.clientX - r.left - self.grab) / r.width * 100); };
      if (h) {
        h.addEventListener('pointerdown', function(e){
          e.preventDefault(); e.stopPropagation();
          try { h.setPointerCapture(e.pointerId); } catch (err) {}
          var r = f.getBoundingClientRect();
          self.grab = e.clientX - (r.left + r.width * self.pos / 100);
          self.drag = true; f.classList.add('is-dragging', 'is-touched');
        });
        h.addEventListener('pointermove', function(e){ if (self.drag) set(e); });
        var up = function(){ if (!self.drag) return; self.drag = false; f.classList.remove('is-dragging'); self.idle = performance.now(); };
        h.addEventListener('pointerup', up); h.addEventListener('pointercancel', up); h.addEventListener('lostpointercapture', up);
      }
      f.addEventListener('keydown', function(e){
        var d = e.key === 'ArrowLeft' ? -5 : e.key === 'ArrowRight' ? 5 : 0;
        if (!d) return; e.preventDefault();
        f.classList.add('is-touched'); self.idle = performance.now(); self.setPos(self.pos + d);
      });
      this.thumbs.forEach(function(b, i){ b.addEventListener('click', function(){ self.idle = performance.now(); self.show(i); }); });
      this.setPos(50); this.show(0);
    }
    setPos(p) {
      this.pos = clamp(p, 0, 100);
      var f = this.frame;
      f.style.setProperty('--pos', this.pos + '%');
      f.style.setProperty('--bo', clamp((this.pos - 8) / 14, 0, 1));
      f.style.setProperty('--ao', clamp((92 - this.pos) / 14, 0, 1));
      f.setAttribute('aria-valuenow', Math.round(this.pos));
    }
    hydrate(layer) {
      if (!layer) return;
      Array.prototype.forEach.call(layer.querySelectorAll('template[data-defer]'), function(t){ t.replaceWith(t.content.cloneNode(true)); });
    }
    show(i) {
      var self = this; this.idx = (i + this.n) % this.n; this.sT = 0;
      this.hydrate(this.layers[this.idx]); this.hydrate(this.layers[(this.idx + 1) % this.n]);
      this.layers.forEach(function(l, k){ l.classList.toggle('is-active', k === self.idx); });
      this.thumbs.forEach(function(b, k){
        b.classList.toggle('is-active', k === self.idx);
        if (k === self.idx) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
        var bar = b.querySelector('.cba-thumb__bar'); if (bar) bar.style.width = '0%';
      });
    }
    tickSlider(dt, t) {
      if (!this.auto || this.drag || t - this.idle < 3000) return;
      this.sway += dt;
      var tg = 50 + 26 * Math.sin(this.sway * Math.PI / this.speed);
      this.setPos(this.pos + (tg - this.pos) * Math.min(1, dt * 3));
      if (this.n > 1) {
        this.sT += dt; var L = this.speed * 4;
        var bar = this.thumbs[this.idx] && this.thumbs[this.idx].querySelector('.cba-thumb__bar');
        if (bar) bar.style.width = Math.min(100, this.sT / L * 100) + '%';
        if (this.sT > L) this.show(this.idx + 1);
      }
    }

    /* ---------- Side-by-side strip ---------- */
    initStrip() {
      var self = this;
      this.vp = this.querySelector('.cba-viewport');
      this.track = this.querySelector('.cba-track');
      this.cards = Array.prototype.slice.call(this.querySelectorAll('.cba-card'));
      this.barEl = this.querySelector('.cba-bar span');
      this.insp = this.querySelector('.cba-inspect');
      this.x = 0; this.vel = this.auto ? 26 : 0; this.idle = -1e9; this.open = -1; this.down = false;
      if (!this.vp || !this.track) return;
      this.measure();
      this._rs = function(){ self.measure(); };
      window.addEventListener('resize', this._rs);
      var vp = this.vp;
      vp.addEventListener('pointerdown', function(e){
        self.down = true; self.moved = false; self.acc = 0;
        self.px = e.clientX; self.pt = performance.now(); self.pid = e.pointerId; self.vel = 0;
      });
      vp.addEventListener('pointermove', function(e){
        if (!self.down) return;
        var dx = e.clientX - self.px, now = performance.now();
        self.acc += Math.abs(dx);
        if (!self.moved && self.acc > 6) {
          self.moved = true; vp.classList.add('is-dragging');
          try { vp.setPointerCapture(self.pid); } catch (err) {}
        }
        if (self.moved) { self.x -= dx; self.vel = -dx / Math.max(0.008, (now - self.pt) / 1000); self.render(); }
        self.px = e.clientX; self.pt = now;
      });
      var up = function(){
        if (!self.down) return; self.down = false; vp.classList.remove('is-dragging'); self.idle = performance.now();
        if (self.moved) {
          self.justDragged = true; setTimeout(function(){ self.justDragged = false; }, 60);
          self.vel = clamp(self.vel, -1800, 1800);
          if (performance.now() - self.pt > 80) self.vel = 0;
        }
      };
      vp.addEventListener('pointerup', up); vp.addEventListener('pointercancel', up);
      this.cards.forEach(function(c){
        c.addEventListener('click', function(){ if (!self.justDragged) self.openPair(parseInt(c.dataset.index, 10)); });
      });
      if (this.insp) {
        var q = function(s){ return self.insp.querySelector(s); };
        if (q('[data-close]')) q('[data-close]').addEventListener('click', function(){ self.closePair(); });
        if (q('[data-prev]')) q('[data-prev]').addEventListener('click', function(){ self.openPair(self.open - 1); });
        if (q('[data-next]')) q('[data-next]').addEventListener('click', function(){ self.openPair(self.open + 1); });
        this.addEventListener('keydown', function(e){ if (e.key === 'Escape' && self.open >= 0) self.closePair(); });
      }
      this.render();
    }
    measure() {
      var c = this.cards[0]; if (!c) return;
      var gap = parseFloat(getComputedStyle(this.track).columnGap) || 10;
      this.cw = c.offsetWidth; this.pitch = this.cw + gap; this.loop = this.pitch * this.n;
      this.render();
    }
    render() {
      if (!this.loop) return;
      var xm = ((this.x % this.loop) + this.loop) % this.loop;
      var vc = this.vp.clientWidth / 2;
      var tx = -this.loop - xm + (vc - this.cw / 2);
      this.track.style.transform = 'translate3d(' + tx.toFixed(2) + 'px,0,0)';
      var self = this;
      this.cards.forEach(function(c, k){
        var d = Math.abs(k * self.pitch + tx + self.cw / 2 - vc);
        var f = 1 - Math.min(1, d / self.pitch);
        c.style.transform = 'scale(' + (0.9 + 0.1 * f).toFixed(3) + ')';
        c.style.opacity = (0.55 + 0.45 * f).toFixed(3);
        c.classList.toggle('is-focus', f > 0.6);
      });
      if (this.barEl) this.barEl.style.left = (xm / this.loop * 100) + '%';
    }
    tickStrip(dt, t) {
      if (this.down || this.open >= 0 || !this.loop) return;
      var target = this.auto && (t - this.idle > 1500) ? 26 : 0;
      this.vel += (target - this.vel) * Math.min(1, dt * (Math.abs(this.vel) > 60 ? 2.2 : 1.2));
      if (Math.abs(this.vel) < 0.05 && target === 0) return;
      this.x += this.vel * dt; this.render();
    }
    openPair(i) {
      if (!this.insp) return;
      this.open = ((i % this.n) + this.n) % this.n;
      var card = this.querySelector('.cba-card[data-index="' + this.open + '"]');
      var self = this;
      ['before', 'after'].forEach(function(side){
        var src = card && card.querySelector('.cba-half--' + side + ' .cba-media');
        var slot = self.insp.querySelector('[data-slot="' + side + '"]');
        if (!src || !slot) return;
        slot.innerHTML = src.innerHTML;
        Array.prototype.forEach.call(slot.querySelectorAll('img'), function(img){ img.sizes = '(min-width: 1024px) 320px, 50vw'; img.loading = 'eager'; });
      });
      var cnt = this.insp.querySelector('.cba-inspect-count');
      if (cnt) cnt.textContent = (this.insp.dataset.counter || '[count] / [total]').replace('[count]', this.open + 1).replace('[total]', this.n);
      this.insp.hidden = false; this.classList.add('is-open');
      var close = this.insp.querySelector('[data-close]'); if (close) close.focus({ preventScroll: true });
    }
    closePair() {
      if (!this.insp) return;
      this.open = -1; this.insp.hidden = true; this.classList.remove('is-open');
      this.idle = performance.now(); this.measure();
    }
  }
  customElements.define('crack-before-after', CrackBeforeAfter);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-review-block"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__prbInit) return;
    window.__prbInit = true;

    // Read more
    class PrbClamp extends HTMLElement {
      connectedCallback() {
        this.text = this.querySelector('[data-prb-text]');
        this.btn = this.querySelector('[data-prb-more]');
        if (!this.text || !this.btn) return;
        this.btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const open = !this.hasAttribute('data-open');
          this.toggleAttribute('data-open', open);
          this.btn.setAttribute('aria-expanded', open);
          this.btn.querySelector('[data-label-more]').hidden = open;
          this.btn.querySelector('[data-label-less]').hidden = !open;
        });
        this.ro = new ResizeObserver(() => this.measure());
        this.ro.observe(this.text);
        this.measure();
      }
      disconnectedCallback() { this.ro && this.ro.disconnect(); }
      measure() {
        if (this.hasAttribute('data-open')) return;
        const over = this.text.scrollHeight > this.text.clientHeight + 2;
        this.toggleAttribute('data-overflow', over);
        this.btn.hidden = !over;
      }
    }
    if (!customElements.get('prb-clamp')) customElements.define('prb-clamp', PrbClamp);

    // Carousel
    class ProductReviewCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-prb-track]');
        this.dotsEl = this.querySelector('[data-prb-dots]');
        this.prevBtn = this.querySelector('[data-prb-prev]');
        this.nextBtn = this.querySelector('[data-prb-next]');
        if (!this.track) return;
        this.prevBtn && this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
        this.nextBtn && this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
        this.track.addEventListener('scroll', () => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(() => this.sync()); }, { passive: true });
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
        });
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.slides().indexOf(e.target.closest('[data-prb-slide]'));
          if (i > -1) this.go(i, false);
        });
        this.ro = new ResizeObserver(() => this.build());
        this.ro.observe(this.track);
        this.build();
      }
      disconnectedCallback() { this.ro && this.ro.disconnect(); }
      slides() { return [...this.track.querySelectorAll('[data-prb-slide]')].filter((s) => s.offsetParent !== null); }
      build() {
        const n = this.slides().length;
        if (this.dotsEl && this.dotsEl.childElementCount !== n) {
          this.dotsEl.innerHTML = '';
          for (let i = 0; i < n; i++) {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'prb-dot';
            b.setAttribute('aria-label', `Go to review ${i + 1} of ${n}`);
            b.addEventListener('click', () => this.go(i));
            this.dotsEl.appendChild(b);
          }
        }
        this.querySelector('.prb-nav').hidden = n < 2;
        this.sync();
      }
      sync() {
        const slides = this.slides();
        if (!slides.length) return;
        const left = this.track.scrollLeft;
        const atEnd = left + this.track.clientWidth >= this.track.scrollWidth - 4;
        let i = 0, best = Infinity;
        slides.forEach((s, k) => { const d = Math.abs(s.offsetLeft - this.track.offsetLeft - left); if (d < best) { best = d; i = k; } });
        if (atEnd) i = slides.length - 1;
        this.index = i;
        [...(this.dotsEl ? this.dotsEl.children : [])].forEach((d, k) => d.setAttribute('aria-current', k === i));
        if (this.prevBtn) this.prevBtn.disabled = i === 0;
        if (this.nextBtn) this.nextBtn.disabled = i === slides.length - 1;
      }
      go(i, smooth = true) {
        const slides = this.slides();
        if (!slides.length) return;
        i = Math.max(0, Math.min(slides.length - 1, i));
        this.track.scrollTo({ left: slides[i].offsetLeft - this.track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      }
    }
    if (!customElements.get('product-review-carousel')) customElements.define('product-review-carousel', ProductReviewCarousel);

    // Photo lightbox (shared)
    let dlg, imgEl, countEl, photos = [], at = 0;
    const icon = (d) => `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${d}"/></svg>`;
    function ensureDialog() {
      if (dlg) return;
      dlg = document.createElement('dialog');
      dlg.className = 'prb-lightbox';
      dlg.setAttribute('aria-label', 'Customer photo');
      dlg.innerHTML = `<div class="prb-lightbox__inner">
        <div class="prb-lightbox__bar"><span data-count></span><button type="button" class="prb-lightbox__btn" data-close aria-label="Close">${icon('M6 6l12 12M18 6L6 18')}</button></div>
        <img class="prb-lightbox__img" alt="">
        <button type="button" class="prb-lightbox__btn prb-lightbox__nav prb-lightbox__nav--prev" data-step="-1" aria-label="Previous photo">${icon('M15 5l-7 7 7 7')}</button>
        <button type="button" class="prb-lightbox__btn prb-lightbox__nav prb-lightbox__nav--next" data-step="1" aria-label="Next photo">${icon('M9 5l7 7-7 7')}</button>
      </div>`;
      document.body.appendChild(dlg);
      imgEl = dlg.querySelector('img');
      countEl = dlg.querySelector('[data-count]');
      dlg.addEventListener('click', (e) => {
        const step = e.target.closest('[data-step]');
        if (step) return show(at + Number(step.dataset.step));
        if (e.target.closest('[data-close]') || e.target === dlg || e.target.classList.contains('prb-lightbox__inner')) dlg.close();
      });
      dlg.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') show(at + 1);
        if (e.key === 'ArrowLeft') show(at - 1);
      });
      dlg.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
    }
    function show(i) {
      at = (i + photos.length) % photos.length;
      imgEl.src = photos[at];
      countEl.textContent = photos.length > 1 ? `${at + 1} / ${photos.length} · ${dlg.dataset.caption}` : dlg.dataset.caption;
    }
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-prb-photo]');
      if (!btn) return;
      const root = btn.closest('[data-prb]');
      if (!root || root.dataset.zoom !== 'true') return;
      e.preventDefault();
      e.stopPropagation();
      const wrap = btn.closest('[data-prb-photos]');
      try { photos = JSON.parse(wrap.dataset.prbPhotos); } catch (err) { return; }
      ensureDialog();
      dlg.dataset.caption = wrap.dataset.prbCaption || '';
      dlg.toggleAttribute('data-single', photos.length < 2);
      show(Number(btn.dataset.prbPhoto) || 0);
      document.documentElement.style.overflow = 'hidden';
      dlg.showModal();
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video-carousel-block"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__dvcBoot) return;
  window.__dvcBoot = 1;
  const conn = navigator.connection || {};
  const lite = () => !!(conn.saveData || /2g|3g/.test(conn.effectiveType || '') || matchMedia('(prefers-reduced-motion: reduce)').matches);
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const MAX = matchMedia('(min-width: 768px)').matches ? 3 : 2;
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  const pick = (set, w) => {
    const l = (set || '').split(',').map(s => { const p = s.trim().split(/\s+/); return { u: p[0], w: parseInt(p[1]) || 0 }; }).filter(o => o.u).sort((a, b) => a.w - b.w);
    return l.length ? (l.find(o => o.w >= w) || l[l.length - 1]).u : '';
  };
  window.__dvcPick = pick;
  const srcFor = it => {
    if (it.hls && document.createElement('video').canPlayType('application/vnd.apple.mpegurl')) return it.hls;
    const w = matchMedia('(min-width: 768px)').matches ? Math.min((innerHeight - 48) * 9 / 16, innerWidth - 200) : innerWidth;
    return pick(it.srcset, Math.min(w * dpr, lite() ? 540 : 1080));
  };
  window.__dvcSrc = srcFor;

  let warm = null;
  const dropWarm = () => {
    if (!warm) return;
    clearTimeout(warm.timer);
    warm.v.removeAttribute('src'); warm.v.load();
    warm = null;
  };
  function warmUp(t, e) {
    if (lite() || (warm && warm.id === t.dataset.id)) return;
    dropWarm();
    const v = document.createElement('video');
    v.preload = 'auto'; v.playsInline = true; v.setAttribute('playsinline', '');
    v.src = srcFor(t.dataset);
    warm = { id: t.dataset.id, v, x: e.clientX, y: e.clientY, timer: setTimeout(dropWarm, 1200) };
  }

  let playerP = null;
  const loadPlayer = root => playerP || (playerP = new Promise((res, rej) => {
    if (window.DreamerFeed) return res(window.DreamerFeed);
    const s = document.createElement('script');
    s.src = root.dataset.player; s.async = true;
    s.onload = () => window.DreamerFeed ? res(window.DreamerFeed) : rej();
    s.onerror = () => { playerP = null; rej(); };
    document.head.appendChild(s);
  }));

  const playing = new Set(), want = new Set(), seen = new WeakSet();
  let feedOpen = false, loaded = document.readyState === 'complete';

  function start(t) {
    if (!loaded || feedOpen || document.hidden || playing.has(t) || playing.size >= MAX) return;
    if (t.hasAttribute('data-no-preview') || !t.dataset.srcset || t.classList.contains('is-inline')) return;
    clearTimeout(t.__kill);
    let v = t.__v;
    if (!v) {
      v = document.createElement('video');
      v.className = 'dvc-pv';
      v.muted = v.defaultMuted = v.loop = v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
      v.preload = 'auto'; v.tabIndex = -1; v.disableRemotePlayback = true;
      v.addEventListener('playing', () => t.classList.add('is-pv'));
      v.src = pick(t.dataset.srcset, t.clientWidth * dpr);
      t.querySelector('.dvc-media').appendChild(v);
      t.__v = v;
    }
    playing.add(t);
    const p = v.play();
    if (p) p.catch(() => stop(t, true));
  }
  function stop(t, now) {
    playing.delete(t);
    const v = t.__v;
    if (!v) return;
    v.pause();
    clearTimeout(t.__kill);
    const kill = () => { t.classList.remove('is-pv'); v.removeAttribute('src'); v.load(); v.remove(); t.__v = null; };
    if (now) kill(); else t.__kill = setTimeout(kill, 8000);
    fill();
  }
  function fill() { for (const w of want) { if (playing.size >= MAX) break; start(w); } }

  const io = 'IntersectionObserver' in window ? new IntersectionObserver(es => {
    for (const e of es) {
      if (e.intersectionRatio >= 0.6) { want.add(e.target); start(e.target); }
      else { want.delete(e.target); stop(e.target); }
    }
  }, { threshold: [0, 0.6] }) : null;

  function initNav(root) {
    const sc = root.querySelector('slider-carousel');
    if (!sc || root.__nav) return;
    root.__nav = 1;
    const dots = root.querySelector('.dvc-dots');
    let tries = 0;
    const bind = c => {
      const upd = () => {
        root.classList.toggle('dvc-can-prev', c.canScrollPrev());
        root.classList.toggle('dvc-can-next', c.canScrollNext());
        if (dots) {
          const i = c.selectedScrollSnap();
          dots.querySelectorAll('.dvc-dot').forEach((d, j) => d.setAttribute('aria-current', j === i ? 'true' : 'false'));
        }
      };
      const build = () => {
        if (dots) {
          const n = c.scrollSnapList().length;
          dots.textContent = '';
          dots.hidden = n < 2 || n > 12;
          for (let j = 0; j < n; j++) {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'dvc-dot';
            b.setAttribute('aria-label', 'Go to slide ' + (j + 1));
            b.addEventListener('click', () => c.scrollTo(j));
            dots.appendChild(b);
          }
        }
        upd();
      };
      c.on('select', upd);
      c.on('settle', upd);
      c.on('reInit', build);
      build();
    };
    const wait = () => {
      const c = sc.carousel;
      if (c && typeof c.on === 'function') bind(c);
      else if (++tries < 80) setTimeout(wait, 150);
    };
    wait();
  }

  const warmIO = 'IntersectionObserver' in window ? new IntersectionObserver(es => {
    for (const e of es) if (e.isIntersecting) {
      warmIO.unobserve(e.target);
      const go = () => loadPlayer(e.target).catch(() => {});
      'requestIdleCallback' in window ? requestIdleCallback(go, { timeout: 3000 }) : setTimeout(go, 1500);
    }
  }, { rootMargin: '300px' }) : null;

  function scan(root) {
    const mode = root.dataset.preview;
    root.querySelectorAll('[data-dvc-item]').forEach(t => {
      if (seen.has(t)) return;
      seen.add(t);
      if (lite()) return;
      if (mode === 'visible' && io) io.observe(t);
      else if (mode === 'hover' && fine.matches) {
        t.addEventListener('pointerenter', () => { want.add(t); start(t); });
        t.addEventListener('pointerleave', () => { want.delete(t); stop(t); });
      }
    });
  }
  function init() {
    document.querySelectorAll('[data-dvc]').forEach(root => {
      if (!root.__mo) {
        let q = 0;
        root.__mo = new MutationObserver(() => { if (!q) q = requestAnimationFrame(() => { q = 0; scan(root); }); });
        root.__mo.observe(root, { childList: true, subtree: true });
        if (warmIO) warmIO.observe(root);
        initNav(root);
      }
      scan(root);
    });
  }

  function itemsOf(root) {
    const ids = new Set(), out = [];
    root.querySelectorAll('[data-dvc-item]').forEach(el => {
      const id = el.dataset.id;
      if (ids.has(id) || !el.getClientRects().length) return;
      ids.add(id);
      out.push(Object.assign({}, el.dataset));
    });
    return out;
  }

  function inline(t) {
    stop(t, true);
    document.querySelectorAll('.dvc-inline').forEach(x => x.pause());
    if (t.__iv) { t.__iv.play(); return; }
    const v = document.createElement('video');
    v.className = 'dvc-inline';
    v.controls = v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.preload = 'auto';
    if (t.dataset.poster) v.poster = t.dataset.poster;
    const h = t.dataset.hls;
    v.src = h && v.canPlayType('application/vnd.apple.mpegurl') ? h : pick(t.dataset.srcset, t.clientWidth * dpr * 1.5);
    t.appendChild(v);
    t.__iv = v;
    t.classList.add('is-inline');
    want.delete(t);
    if (io) io.unobserve(t);
    v.play().catch(() => { v.muted = true; v.play().catch(() => {}); });
  }

  function openFeed(t, root) {
    const items = itemsOf(root);
    const idx = Math.max(0, items.findIndex(i => i.id === t.dataset.id));
    feedOpen = true;
    [...playing].forEach(x => stop(x));
    let w = null;
    if (warm && warm.id === t.dataset.id) { clearTimeout(warm.timer); w = { id: warm.id, v: warm.v }; warm = null; }
    else dropWarm();
    const opts = {
      warm: w,
      accent: getComputedStyle(root).getPropertyValue('--dvc-accent').trim(),
      end: root.dataset.end || 'loop',
      sound: root.dataset.sound !== 'false',
      returnFocus: t.querySelector('[data-dvc-open]'),
      onClose: () => { feedOpen = false; fill(); }
    };
    if (window.DreamerFeed) window.DreamerFeed.open(items, idx, opts);
    else loadPlayer(root).then(F => F.open(items, idx, opts)).catch(() => { feedOpen = false; if (w) { w.v.removeAttribute('src'); w.v.load(); } inline(t); });
  }

  document.addEventListener('click', e => {
    const b = e.target.closest && e.target.closest('[data-dvc-open]');
    if (!b) return;
    const t = b.closest('[data-dvc-item]'), root = t && t.closest('[data-dvc]');
    if (!root) return;
    e.preventDefault();
    root.dataset.inline === 'true' ? inline(t) : openFeed(t, root);
  });
  const intent = e => { const r = e.target.closest && e.target.closest('[data-dvc]'); if (r && r.dataset.inline !== 'true') loadPlayer(r).catch(() => {}); };
  document.addEventListener('pointerdown', e => {
    intent(e);
    if (e.button > 0) return;
    const b = e.target.closest && e.target.closest('[data-dvc-open]');
    const t = b && b.closest('[data-dvc-item]'), r = t && t.closest('[data-dvc]');
    if (r && r.dataset.inline !== 'true') warmUp(t, e);
  }, { passive: true });
  document.addEventListener('pointermove', e => { if (warm && Math.hypot(e.clientX - warm.x, e.clientY - warm.y) > 8) dropWarm(); }, { passive: true });
  document.addEventListener('pointercancel', dropWarm, { passive: true });
  document.addEventListener('focusin', intent);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) [...playing].forEach(t => { playing.delete(t); t.__v && t.__v.pause(); });
    else fill();
  });
  window.addEventListener('load', () => { loaded = true; fill(); }, { once: true });
  document.addEventListener('shopify:section:load', init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
  } catch(e) { console.error(e); }
})();

})();
